// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kzHBJ","fullView":"styles_fullView__2SBU1"};